export default __webpack_public_path__ + "static/media/main_pc@2x.7bc427bb.jpg";